<div class="not_found_container">
    <h1> (>_<) </h1>

            <p>Oops! Page not found</p>
</div>